module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._c('li', [_vm._c('a', {
    attrs: {
      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
    }
  }, [_vm._v("Sign Up")])]), _vm._v(" "), _vm._c('li', [_vm._c('a', {
    attrs: {
      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
    }
  }, [_vm._v("Log In")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16d853a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/LoggedOutLinks.vue
// module id = 626
// module chunks = 1